// Derives a short, punchy display word from a learner's role (e.g. "Data
// Analytics learner" -> "DATA") for the badge shown on story cards, since
// submissions don't carry a hand-picked tagline of their own. Prefers the
// shortest meaningful word so the badge stays compact.
const STOPWORDS = new Set([
  "a",
  "an",
  "the",
  "of",
  "to",
  "in",
  "on",
  "for",
  "and",
  "at",
  "is",
  "are",
  "with",
  "learner",
]);

export const getMarkerWord = (role = "") => {
  // Most submissions read "<role> at/@/- <company>" — the role itself is
  // what's worth badging, not whichever word in the company name happens
  // to be shortest, so drop everything from the first separator onward.
  const rolePart = role.split(/\s+(?:at|@|\/|-|,)\s+/i)[0] || role;
  const words = rolePart
    .replace(/[^\w\s]/g, "")
    .split(/\s+/)
    .filter(Boolean);
  const candidates = words
    .filter((w) => w.length >= 3 && !STOPWORDS.has(w.toLowerCase()))
    .sort((a, b) => a.length - b.length);
  const candidate = candidates[0] || words[0] || "STORY";
  return candidate.toUpperCase().slice(0, 12);
};
